import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundleOverridesLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleOverridesLayout } = await import(
    "@workflows/bundles/overrides/bundle-overrides/bundle-overrides-layout/BundleOverridesLayout"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_OVERRIDES}>
      <BundleOverridesLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleOverridesLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleOverrides } = await import("@workflows/bundles/overrides/bundle-overrides");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_OVERRIDES}>
      <BundleOverrides />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleOverridesCreateLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { BundleOverrideCreateAndEditPanel } = await import(
    "@workflows/bundles/overrides/bundle-overrides/bundle-override-panels/bundle-override-create-and-edit/BundleOverrideCreateAndEditPanel"
  );
  const { BundleOverrideFormType } = await import(
    "@workflows/bundles/overrides/bundle-overrides/bundle-override-panels/bundle-override-create-and-edit/BundleOverridesCreateAndEditPanel.types"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_OVERRIDES}>
      <BundleOverrideCreateAndEditPanel type={BundleOverrideFormType.CREATE} />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
